export default __webpack_public_path__ + "static/img3-713c8688d4ad36a39d0416d2aef3a827.jpg";